module.exports = __webpack_public_path__ + "img/ufa-bet-support.133db9c1.png";